import { MessageCircle } from 'lucide-react';

const WHATSAPP_NUMBER = '5548991904829';
const DEFAULT_MESSAGE = 'Olá! Gostaria de solicitar um orçamento para uma viagem.';

export default function WhatsAppFloat({ message = DEFAULT_MESSAGE }) {
  const url = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;
  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Fale conosco no WhatsApp"
      className="fixed bottom-5 right-5 md:bottom-6 md:right-6 z-[100] group"
    >
      <span className="absolute inset-0 rounded-full bg-[#25D366] opacity-70 animate-ping" style={{ animationDuration: '2.2s' }}></span>
      <span className="relative flex items-center justify-center w-14 h-14 md:w-16 md:h-16 rounded-full bg-[#25D366] text-white shadow-2xl transition-transform duration-300 group-hover:scale-110">
        <svg viewBox="0 0 32 32" fill="currentColor" className="w-7 h-7 md:w-8 md:h-8" aria-hidden="true">
          <path d="M19.11 17.28c-.28-.14-1.66-.82-1.92-.91-.26-.09-.44-.14-.62.14-.19.28-.72.91-.88 1.09-.16.19-.32.21-.6.07-.28-.14-1.18-.44-2.25-1.4-.83-.74-1.39-1.66-1.55-1.94-.16-.28-.02-.44.12-.58.13-.13.28-.32.42-.49.14-.16.19-.28.28-.47.09-.19.05-.35-.02-.49-.07-.14-.62-1.51-.85-2.06-.22-.53-.45-.46-.62-.47l-.53-.01c-.19 0-.49.07-.75.35-.26.28-.98.96-.98 2.34s1 2.71 1.14 2.9c.14.19 1.98 3.03 4.79 4.24.67.29 1.19.46 1.6.59.67.21 1.28.18 1.76.11.54-.08 1.66-.68 1.89-1.34.23-.66.23-1.23.16-1.34-.07-.11-.26-.19-.54-.33zM16 3C8.83 3 3 8.83 3 16c0 2.51.72 4.86 1.97 6.84L3 29l6.34-1.94A12.9 12.9 0 0 0 16 29c7.17 0 13-5.83 13-13S23.17 3 16 3zm0 23.68c-2.2 0-4.28-.66-6.03-1.79l-.43-.27-3.77 1.15 1.17-3.68-.28-.45A10.65 10.65 0 0 1 5.32 16C5.32 10.11 10.11 5.32 16 5.32S26.68 10.11 26.68 16 21.89 26.68 16 26.68z"/>
        </svg>
      </span>
      <span className="pointer-events-none absolute right-full mr-3 top-1/2 -translate-y-1/2 whitespace-nowrap rounded-lg bg-primary text-primary-foreground text-xs font-semibold px-3 py-2 shadow-lg opacity-0 group-hover:opacity-100 transition-opacity duration-200 hidden md:inline-block">
        Fale conosco no WhatsApp
      </span>
    </a>
  );
}
